<script>
    /*
    * Mixin_Home_DragAndDrop.js
    *
    * Description: Mixin File for Home.vue. Includes: D&D Features.
    *
    * This file is part of: "http://apps.sundair.com/", "SunCrew2 - Crewplanning"
    * Copyright 2018,2019,2020,2021,2022,2023 Sundair GmbH
    * Contact:  http://www.sundair.com/
    * @author Christian Arp <christian.arp@sundair.com>
    * @author Learek <michael.broeker@sundair.com>
    * @author Phillip Alsleben <phillip.alsleben@sundair.com>
    *
    */
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../main';
    import dayjs from "dayjs";
    import utc from 'dayjs/plugin/utc';


    export default {
        name: 'CrewplanningHomeMixinDragAndDrop',

        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
                'get_shared_Warning',
                // >>> ------------------------------------
                'get_selectedMultiResources', // 'Calendar'
                'get_selectedMultiEvents', // 'Calendar'
                'get_selectedMultiEventsFlights',
                'get_selectedMultiEventsEntireRecordFlights',
                'get_selectedMultiResourcesFlights',
                'get_shared_IsDutyAccessAllowed',
                'get_shared_IsSchedulerReadOnly'
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> created');
            eventBus.$on('eventSelectionChange_Flights', this.eventSelectionChange_Flights_Handler);
            eventBus.$on('selectionChange_Flights', this.resourceSelectionChange_Flights_Handler);

            // eventBus.$on('beforeEventEdit_Flights', this.beforeEventEdit_Flights_Handler);
            eventBus.$on('eventBeforeEventDropFinalize_FlightsToCalendar', this.eventBeforeEventDropFinalize__FlightsToCalendar_Handler);

            // >>> ----------------------------------------
            eventBus.$on('createnewflightinflights', this.onCreate_FlightsInFLights);
            eventBus.$on('createnewflightformember', this.onCreate_FlightsForCrewMembersInCalendar);
            eventBus.$on('createnewflightformember2', this.onCreate_FlightsForCrewMembersInCalendar2);
            eventBus.$on('createnewflightformemberafterdelete', this.onCreate_FlightsForCrewMembersInCalendarAfterDelete);

            eventBus.$on('deletedraggedflightformember', this.onDelete_DraggedFlightsForCrewMembersInCalendar);

            eventBus.$on('updateflightsinflightswithnewcrew', this.onUpdate_FlightsInFlightsWithNewCrew);
            eventBus.$on('deleteflightforcrewmember', this.onDelete_FlightsForCrewMembersInCalendar);
            eventBus.$on('updateflightsincalendarswithnewcrew', this.onUpdate_FlightsInCalendarWithNewCrew);


            // >>> ----------------------------------------
            eventBus.$on('onclickdeletememberonflight', this.onDelete_MemberFromFlight);
            eventBus.$on('onclickseecrewdetails', this.onShow_CrewDetails);
            eventBus.$on('onclickupdatecrewonflight', this.onUpdate_CrewOnFlight);
            eventBus.$on('closeupdatecrewsheet', this.onCloseSheet_CrewOnFlight);
            eventBus.$on('onclickfilterforcrewoncalendar', this.onFilter_ForCrewOnCalendar);

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> destroyed');
            eventBus.$off('eventSelectionChange_Flights', this.eventSelectionChange_Flights_Handler);
            eventBus.$off('selectionChange_Flights', this.resourceSelectionChange_Flights_Handler);

            // eventBus.$off('beforeEventEdit_Flights', this.beforeEventEdit_Flights_Handler);
            eventBus.$off('eventBeforeEventDropFinalize_FlightsToCalendar', this.eventBeforeEventDropFinalize__FlightsToCalendar_Handler);

            // >>> ----------------------------------------
            eventBus.$off('createnewflightinflights', this.onCreate_FlightsInFLights);
            eventBus.$off('createnewflightformember', this.onCreate_FlightsForCrewMembersInCalendar);
            eventBus.$off('createnewflightformember2', this.onCreate_FlightsForCrewMembersInCalendar2);
            eventBus.$on('createnewflightformemberafterdelete', this.onCreate_FlightsForCrewMembersInCalendarAfterDelete);

            eventBus.$off('deletedraggedflightformember', this.onDelete_DraggedFlightsForCrewMembersInCalendar);

            eventBus.$off('updateflightsinflightswithnewcrew', this.onUpdate_FlightsInFlightsWithNewCrew);
            eventBus.$off('deleteflightforcrewmember', this.onDelete_FlightsForCrewMembersInCalendar);
            eventBus.$off('updateflightsincalendarswithnewcrew', this.onUpdate_FlightsInCalendarWithNewCrew);


            // >>> ----------------------------------------
            eventBus.$off('onclickdeletememberonflight', this.onDelete_MemberFromFlight);
            eventBus.$off('onclickseecrewdetails', this.onShow_CrewDetails);
            eventBus.$off('onclickupdatecrewonflight', this.onUpdate_CrewOnFlight);
            eventBus.$off('closeupdatecrewsheet', this.onCloseSheet_CrewOnFlight);
            eventBus.$on('onclickfilterforcrewoncalendar', this.onFilter_ForCrewOnCalendar);

		}, // eo function destroyed()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_set_Warning',
                'actn_reset_DraggedFlightsInFlightsAndCalendar',
                // >>> ------------------------------------
                'actn_set_SelectedMultiEvents_Flights',
                'actn_set_SelectedMultiResources_Flights',
                // >>> ------------------------------------
                'actn_call_addCrewmemberOnFlights' , // Call: Add CrewMember on Flights (via D&D or Resources Context Menue)
                'actn_call_deleteCrewmemberFromFlights' , // Call: Delete CrewMember from Flights (via Flight Events Context Menue)
                'actn_set_getMemberOnCrew', //  mimics Call from People
                // >>> ------------------------------------
                'actn_call_getCrewDetailsFromFlight', // 'Crew Details' Call 1
                'actn_call_getCrewDetailsFromFlight_Reduced', // 'Crew Details' Call 2
            ]),


            /******************************************************************* 'Listeners - Multi Event/Resource Selection'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * beforeEventEdit_Flights_Handler()
            *
            * Desc: Before Event - Edit Handler 'Flights'.
            * Note:
            * TODO: Event is OFF right now!
            * TODO: Return 'false' does not work!
            * TODO: only in correlation with some Dialog.
            *
            * @param {Object} event ()
            */
            beforeEventEdit_Flights_Handler: function(event) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> beforeEventEdit_Flights_Handler');
                this.onClick_FloatingButton();
                return false;

            }, // eo function beforeEventEdit_Flights_Handler()


			/*******************************************************************
			* onClick_FloatingButton()
			*
			* Desc:
			* Note:
			*
			*/
			onClick_FloatingButton: function() {

				let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onClick_FloatingButton');
                me.eventRecord = null;
                me.editorMode = 'create';
                me.showSheetCreate = true;

			}, // eo function onClick_FloatingButton()




            /******************************************************************* 'Listeners - Multi Event/Resource Selection'
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Multi Event Select'
            * eventSelectionChange_Flights_Handler()
            *
            * Desc: Fires on Event Selection (Change) - Handler.
            * Note: Set Selection into State.
            *
            * @param {Object} selection (Object of Selections)
            */
            eventSelectionChange_Flights_Handler: function({ selection }) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> eventSelectionChange_Flights_Handler');
                this.actn_set_SelectedMultiEvents_Flights(selection); // Save in State

            }, // eo function eventSelectionChange_Flights_Handler()


            /******************************************************************* 'Multi Row/Cell Select'
            * resourceSelectionChange_Flights_Handler()
            *
            * Desc: Fires on Row/Cell Selection (Change) - Handler.
            * Note:
            *
            * @param {Object} selection (Object of Selections)
            */
            resourceSelectionChange_Flights_Handler: function(selection) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/Home.vue >>> resourceSelectionChange_Flights_Handler');
                if (selection.mode === 'row') {
                    this.actn_set_SelectedMultiResources_Flights(selection.selection); // Save in State
                }

            }, // eo function resourceSelectionChange_Flights_Handler()




            /*******************************************************************
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * beforeEventDragHandler()
            *
            * Desc:
            * Note: Right now gets handled directly in AppConfig.
            * TODO:
            *
            * @param {Object} eventRecord (EventRecord)
            */
            beforeEventDragHandler: function ({ eventRecord }) {

                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> beforeEventDragHandler');

            }, // eo function beforeEventDragHandler()


            /******************************************************************* 'D&D Flights => Calendar'
            * eventBeforeEventDropFinalize__FlightsToCalendar_Handler()
            *
            * Desc: Dragged events Reaction
            * Note: 2 Ways:
            * Note: a) Get drgd Events from Context.
            * Note: b) Get drgd Events from Global State 'selectedMultiEvents'.
            * Note: Check if edit in past is allowed.
            *
            * TODO: Question: Can we here validate something? (same like: eventDragFeature=>validatorFn)
            *
            * @param {Object} context
            */
            eventBeforeEventDropFinalize__FlightsToCalendar_Handler: async function ({context}) {

                let me = this,
                    { draggedRecords, newResource } = context,
                    params = {},
                    draggedIdFlightsArray = [];


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> eventBeforeEventDropFinalize__FlightsToCalendar_Handler');
                // >>> Step 2: 'Prepare' ------------------
                draggedRecords.forEach(rec => {
                    draggedIdFlightsArray.push(rec.data.legInfo.idFlight)
                });

                params = {
                    params: {
                        "idFlights": draggedIdFlightsArray,
                        "resourcesIdstoAdd": [newResource.data.id],
                        "resourcesIdstoRemove": []
                    },
                    draggedRecords: draggedRecords,
                    newResource: newResource
                };
                // <<< Step 2: 'Prepare' ------------------


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [context.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {

                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    setTimeout(() => {
                        me.actn_reset_DraggedFlightsInFlightsAndCalendar(params);
                    }, 1000);

                } else {

                    // >>> Step 3: 'Warning/Call' ---------
                    me.actn_set_Warning({
                        title: 'Set Crews(s) on Flight(s)',
                        text:   `<div>
                                    <p style="margin: 0; text-align: center">Do you really want to drag these flight(s) ?</p>
                                    <div style="display:flex;padding-top:28px;font-weight:500">
                                        <div style="padding-top:0;flex: 0 0 70px;margin-right:18px;border-right:1px solid #757575;">FlightNo.</div>
                                        <div style="padding-top:0;flex: 1;">Departure Airport</div>
                                        <div style="padding-top:0;flex: 1;">Departure Time</div>
                                        <div style="padding-top:0;flex: 1;">Arrival Time</div>
                                        <div style="padding-top:0;flex: 1;">Arrival Airport</div>
                                        <div style="padding-top:0;flex: 1;">For Member(s)</div>
                                    </div>

                                    ${draggedRecords.map((record) => `
                                        <div style="display:flex;border-top: 1px solid #757575;">
                                            <div style="padding-top:4px;flex: 0 0 70px;margin-right:18px;border-right:1px solid #757575;">${record.data.legInfo.flightNo}</div>
                                            <div style="padding-top:4px;flex: 1;">${record.data.legInfo.aptTo.aptCode}</div>
                                            <div style="padding-top:4px;flex: 1;color:red;">${dayjs(record.data.legInfo.dep_sch_time).utc().format("HH:mm")}</div>
                                            <div style="padding-top:4px;flex: 1;color:red;">${dayjs(record.data.legInfo.arr_sch_time).utc().format("HH:mm")}</div>
                                            <div style="padding-top:4px;flex: 1;">${record.data.legInfo.aptFrom.aptCode}</div>
                                            <div style="padding-top:4px;flex: 1;">${newResource.data.contract3Code}</div>
                                        </div>
                                    `).join(' ')}
                                `,
                        payload: null,
                        acceptFunction: () => me.actn_call_addCrewmemberOnFlights(params),
                        declineFunction: () => me.actn_reset_DraggedFlightsInFlightsAndCalendar(params),
                    });
                    // <<< Step 3: 'Warning/Call' ---------

                }

            }, // eo function eventBeforeEventDropFinalize__FlightsToCalendar_Handler()




            /******************************************************************* 'Listeners Emit - Created/Updated Events'
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Create Flights in Flights'
            * onCreate_FlightsInFLights()
            *
            * Desc:
            * Desc:
            * Note: Using Response of Call:'actn_call_addCrewmemberOnFlights'.
            * Note: 'build_EventsInFlights' is used several times.
            *
            * @param {Object} response (Response from Call)
            */
            onCreate_FlightsInFLights: function(response){

                let me = this,
                    recsToAdd = [],
                    schedulerFlights = this.$refs.scheduler2.instance; // 'Flights'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onCreate_FlightsInFLights');
                recsToAdd = me.$build_EventsInFlights(response);
                setTimeout(function(){
                    schedulerFlights.eventStore.add(recsToAdd);
                }, 500);

            }, // eo function onCreate_FlightsInFLights()


            /******************************************************************* 'Create new Flight for CrewMember in Calendar'
            * onCreate_FlightsForCrewMembersInCalendar()
            *
            * Desc: Add CrewMember to Flight.
            * Note: Using Response of Call:'actn_call_addCrewmemberOnFlights'.
            *
            * @param {Object} response (Response from Call)
            */
            onCreate_FlightsForCrewMembersInCalendar: function(response) {

                let me = this,
                    recsToAdd = [],
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onCreate_FlightsForCrewMembersInCalendar');
                // >>> ------------------------------------ add
                recsToAdd = me.$build_MultipleDuties(response);
                setTimeout(function(){
                    schedulerCalendar.eventStore.add(recsToAdd);
                }, 500);

            }, // eo function onCreate_FlightsForCrewMembersInCalendar()


            /******************************************************************* 'Create new Flight for CrewMember in Calendar 2'
            * onCreate_FlightsForCrewMembersInCalendar2()
            *
            * Desc:
            * Note: Using Response of
            * Note: Call:'actn_call_crews_setDutyTimes',
            * Note: 'actn_call_crews_setFlightRoles'
            *
            * @param {Object} response (Response from Call)
            */
            onCreate_FlightsForCrewMembersInCalendar2: function(response) {

                let me = this,
                    recs = null,
                    recsToAdd = [],
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onCreate_FlightsForCrewMembersInCalendar2');
                // >>> ------------------------------------ delete
                if (response.length) {
                    response.forEach(duty => {
                        duty.flightInfos.forEach(flight => {
                            recs = schedulerCalendar.eventStore.findByField('originalId', flight.id);
                            if (recs.length > 0) {
                                recs.forEach(rec => {
                                    if (rec.data.resourceId === duty.crewMemberInfo.id) {
                                        schedulerCalendar.eventStore.remove(rec.data);
                                    }
                                });
                            }
                        });
                    });
                }


                // >>> ------------------------------------ add
                recsToAdd = me.$build_MultipleDuties(response);


                setTimeout(function(){
                    schedulerCalendar.eventStore.add(recsToAdd);
                }, 800);

            }, // eo function onCreate_FlightsForCrewMembersInCalendar2()


            /******************************************************************* 'Create new Flight for CrewMember in Calendar after Delete'
            * onCreate_FlightsForCrewMembersInCalendarAfterDelete()
            *
            * Desc:
            * Note: Using Response of
            * Note: Call:'actn_call_deleteCrewmemberFromFlights',
            *
            * @param {Object} obj ({ response: response.data.extends4, params: payload.params })
            */
            onCreate_FlightsForCrewMembersInCalendarAfterDelete: function(obj) {

                let me = this,
                    { response, params } = obj,
                    { idFlights, resourcesIdstoRemove } = params,
                    responseFiltered = [],
                    recs = null,
                    recsToDelete = [],
                    recsToAdd = [],
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onCreate_FlightsForCrewMembersInCalendarAfterDelete');
                // >>> ------------------------------------ delete (all)
                if (response.length) {
                    response.forEach(duty => {
                        duty.flightInfos.forEach(flight => {
                            recs = schedulerCalendar.eventStore.findByField('originalId', flight.id);
                            if (recs.length > 0) {
                                recs.forEach(rec => {
                                    if (rec.data.resourceId === duty.crewMemberInfo.id) {
                                        schedulerCalendar.eventStore.remove(rec.data);
                                    }
                                });
                            }
                        });
                    });
                }



                // >>> ------------------------------------ add
                recsToAdd = me.$build_MultipleDuties(response);

                setTimeout(function(){
                    schedulerCalendar.eventStore.add(recsToAdd);
                }, 800);

            }, // eo function onCreate_FlightsForCrewMembersInCalendarAfterDelete()




            /******************************************************************* 'Delete dragged one(s) from Calendar'
            * onDelete_DraggedFlightsForCrewMembersInCalendar()
            *
            * Desc:
            * Note: We delete the dragged ones. A new one is already created.
            *
            * @param {Object} draggedRecords (Dragged Records)
            */
            onDelete_DraggedFlightsForCrewMembersInCalendar: function(draggedRecords) {

                let me = this,
                    recsToDelete = [],
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onDelete_DraggedFlightsForCrewMembersInCalendar');
                if (draggedRecords.length === undefined) {
                    recsToDelete.push(draggedRecords);
                } else {
                    recsToDelete = draggedRecords;
                }

                recsToDelete.forEach((duty) => {
                    schedulerCalendar.eventStore.forEach(rec => {
                        if (rec.data.id === duty.id) {
                            schedulerCalendar.eventStore.remove(rec);
                        }
                    });
                });

            }, // eo function onDelete_DraggedFlightsForCrewMembersInCalendar()




            /******************************************************************* 'Update Flights in Flights w. new Crewinfos'
            * onUpdate_FlightsInFlightsWithNewCrew()
            *
            * Desc: 1.'Del' then 2.'Add' in Flights (with  uodated Flight).
            * Note: Using Response of Call:'actn_call_deleteCrewmemberFromFlights'.
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_FlightsInFlightsWithNewCrew: function(response){

                let me = this,
                    rec = null,
                    recsToAdd = [],
                    schedulerFlights = this.$refs.scheduler2.instance; // 'Flights'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onUpdate_FlightsInFlightsWithNewCrew');
                // >>> ------------------------------------ delete
                if (response.length) {
                    response.forEach(duty => {
                        rec = schedulerFlights.eventStore.findByField('id', duty.idFlight);
                        if (rec) {
                            if (rec.length > 0) {
                                schedulerFlights.eventStore.remove(rec[0].data);
                            }
                        }
                    });
                }


                // >>> ------------------------------------ add
                recsToAdd = me.$build_EventsInFlights(response);
                setTimeout(function(){
                    schedulerFlights.eventStore.add(recsToAdd);
                }, 600);

            }, // eo function onUpdate_FlightsInFlightsWithNewCrew()


            /******************************************************************* 'Delete Flights from Calendar (CrewMember was deleted from Flight)'
            * onDelete_DraggedFlightsForCrewMembersInCalendar()
            *
            * Desc: Delete Flight from Crewmember in Calendar.
            * Note:
            *
            * @param {Array} idFlights (List if idFlights)
            */
            onDelete_FlightsForCrewMembersInCalendar: function(params) {

                let me = this,
                    { idFlights, resourcesIdstoRemove } = params,
                    recsToDelete = [],
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onDelete_FlightsForCrewMembersInCalendar');
                if (idFlights.length === undefined) {
                    recsToDelete.push(idFlights);
                } else {
                    recsToDelete = idFlights;
                }


                // >>> run twice to find all CiCo --------- delete
                recsToDelete.forEach((flightId) => {
                    schedulerCalendar.eventStore.forEach(rec => {
                        if ((rec.data.originalId === flightId) && (resourcesIdstoRemove.includes(rec.data.resourceId))) {
                            // if (rec.data.name === 'FLIGHT') {
                                schedulerCalendar.eventStore.remove(rec);
                            // }
                        }
                    });
                    schedulerCalendar.eventStore.forEach(rec => {
                        if ((rec.data.originalId === flightId) && (resourcesIdstoRemove.includes(rec.data.resourceId))) {
                            // if (rec.data.name === 'FLIGHT') {
                                schedulerCalendar.eventStore.remove(rec);
                            // }
                        }
                    });
                });


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onDelete_FlightsForCrewMembersInCalendar()


            /******************************************************************* 'Update Flights in Calendar w. new Crewinfos'
            * onUpdate_FlightsInCalendarWithNewCrew()
            *
            * Desc: Update Crew in Flight in Calendar.
            * Note: Using Response of Call:'actn_call_deleteCrewmemberFromFlights'.
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_FlightsInCalendarWithNewCrew: function(response){

                let me = this,
                    records = null,
                    mycrew = '',
                    roles = '',
                    tmp = '',
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onUpdate_FlightsInCalendarWithNewCrew');
                if (response.length) {
                    // >>> Crew ------------------------------------------------
                    // crew = response[0].crewCodes.toString(); // 'crew' to set in

                    response[0].crew.forEach((crew, i) => {
                        mycrew = mycrew + crew.contract3Code;

                        tmp = crew.onDuty ? ' <span style="color: red;">DU</span>' : ''; // onDuty
                        tmp += crew.takeoff === true || crew.landing === true ?  '(TL)' : '';
                        tmp += crew.manualStatus === 'C' ?  '(cd)' : '';
                        tmp += crew.manualStatus === 'E' ?  '(e)' : '';
                        mycrew = mycrew + tmp;

                        roles = '';
                        crew.roles.forEach((role, i) => { // Roles
                            roles = roles + ' ' + role.charAt(0);
                        });
                        mycrew = mycrew + roles;

                        mycrew = mycrew  + ',';
                    });
                    mycrew = mycrew.slice(0, -1);


                    response.forEach(flight => {
                        records = schedulerCalendar.eventStore.findByField('originalId', flight.idFlight);
                        records.forEach(rec => {
                            rec.data.set({ crew: mycrew }); // update 'crew'
                        });
                    });
                }


                // >>> Refresh Restriction ----------------
                eventBus.$emit('refreshrestrictions');

            }, // eo function onUpdate_FlightsInCalendarWithNewCrew()




            /*******************************************************************
            * Listeners:
            *******************************************************************/
            /******************************************************************* 'Set Employees on Flight via Calendar Ressources ContextMenue'
            * onClick_EmployeeesOnFlight()
            *
            * Desc:
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} res (Clicked Resource)
            */
            onClick_EmployeeesOnFlight: function(res) {

                let me = this,
                    params = {},
                    idFlightsArray = [],
                    startDatesArray = [],
                    resourcesIdstoAdd = [],
                    resourcesContractCodetoAdd = '';


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onClick_EmployeeesOnFlight');
                // >>> ------------------------------------ guard
                if (this.get_shared_IsSchedulerReadOnly({ scheduler: 'FLIGHTS' })) { // read-only?
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to do this Action.'
                    });
                    return;
                }


                if (this.validator_ResourcesOnFlights() === true) {

                    this.get_selectedMultiEventsFlights().forEach(rec => {
                        idFlightsArray.push(rec.legInfo.idFlight);
                        startDatesArray.push(rec.startDate);
                    });

                    this.get_selectedMultiResources.forEach(rec => {
                        resourcesIdstoAdd.push(rec.data.id)
                        resourcesContractCodetoAdd += rec.data.contract3Code + ', '
                    });

                    params = {
                        params: {
                            "idFlights": idFlightsArray,
                            "resourcesIdstoAdd": resourcesIdstoAdd,
                            "resourcesIdstoRemove": []
                        },
                        draggedRecords: null,
                        newResource: null
                    };


                    if (!Vue.prototype.$isActionAllowed({ datesToCheck: startDatesArray, isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Note: Dear User, no Changes in Past possible.'
                        });
                        return;
                    }


                    // >>> 'Warning/Call' -----------------
                    me.actn_set_Warning({
                        title: 'Set Crews(s) on Flight(s)',
                        text:   `<div>
                                    <p style="margin: 0; text-align: center">Do you really want to drag these flight(s) ?</p>
                                    <div style="display:flex;padding-top:28px;font-weight:500">
                                        <div style="padding-top:0;flex: 0 0 70px;margin-right:18px;border-right:1px solid #757575;">FlightNo.</div>
                                        <div style="padding-top:0;flex: 1;">Departure Airport</div>
                                        <div style="padding-top:0;flex: 1;">Departure Time</div>
                                        <div style="padding-top:0;flex: 1;">Arrival Time</div>
                                        <div style="padding-top:0;flex: 1;">Arrival Airport</div>
                                        <div style="padding-top:0;flex: 1;">For Member(s)</div>
                                    </div>

                                    ${this.get_selectedMultiEventsFlights().map((record) => `
                                        <div style="display:flex;border-top: 1px solid #757575;">
                                            <div style="padding-top:4px;flex: 0 0 70px;margin-right:18px;border-right:1px solid #757575;">${record.legInfo.flightNo}</div>
                                            <div style="padding-top:4px;flex: 1;">${record.legInfo.aptTo.aptCode}</div>
                                            <div style="padding-top:4px;flex: 1;color:red;">${dayjs(record.legInfo.dep_sch_time).utc().format("HH:mm")}</div>
                                            <div style="padding-top:4px;flex: 1;color:red;">${dayjs(record.legInfo.arr_sch_time).utc().format("HH:mm")}</div>
                                            <div style="padding-top:4px;flex: 1;">${record.legInfo.aptFrom.aptCode}</div>
                                            <div style="padding-top:4px;flex: 1;">${resourcesContractCodetoAdd}</div>
                                        </div>
                                    `).join(' ')}
                                `,
                        payload: null,
                        acceptFunction: () => me.actn_call_addCrewmemberOnFlights(params),
                        declineFunction: () => null,
                    });

                }

            }, // eo function onClick_EmployeeesOnFlight()




            /*******************************************************************
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onDelete_MemberFromFlight()
            *
            * Desc:
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} obj (Clicked (single) or Selected (multiple))
            */
            onDelete_MemberFromFlight: function(obj) {

                let me = this,
                    params = {},
                    records = null,
                    idFlightsArray = [],
                    resourcesIdstoRemove = [],
                    startDatesArray = [],
                    resourcesContractCodetoAdd = '',
                    { eventRecord, resourceRecord } = obj,
                    isThisATrainingsFlight = false,
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onDelete_MemberFromFlight');
                // >>> ------------------------------------ guard
                if (!this.get_shared_IsDutyAccessAllowed({ scheduler: 'CALENDAR', grant: 'sc2.calendar.available' })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Attention: Dear User, your are not allowed to create AVAILABLE.'
                    });
                    return;
                }


                // >>> multiple ---------------------------
                if (this.get_selectedMultiEvents('FLIGHT').length > 1) {
                    this.get_selectedMultiEvents('FLIGHT').forEach(rec => {
                        idFlightsArray.push(rec.originalId); // multiple
                        startDatesArray.push(rec.startDate);
                        if (!resourcesIdstoRemove.includes(rec.resourceId))  {
                            if (Vue.prototype.$checkSingleOccurrence(rec.crew, 'I') || Vue.prototype.$checkSingleOccurrence(rec.crew, 'T') || Vue.prototype.$checkSingleOccurrence(rec.crew, 'C')) {
                                isThisATrainingsFlight = true;
                            }

                            resourcesIdstoRemove.push(rec.resourceId);
                        }
                    });

                    resourcesIdstoRemove.forEach(resid => {
                        records = schedulerCalendar.resourceStore.findByField('id', resid);
                        if (records) {
                            resourcesContractCodetoAdd += records[0].data.data.contract3Code + ', ';
                        }
                    })

                }


                // >>> single ----------------------------
                if (this.get_selectedMultiEvents('FLIGHT').length === 0 || this.get_selectedMultiEvents('FLIGHT').length === 1) {
                    this.actn_set_SelectedMultiEvents(Array(eventRecord)); // Save in State
                    this.actn_set_SelectedMultiResources([resourceRecord]); // Save in State
                    idFlightsArray.push(eventRecord.data.originalId); // single
                    startDatesArray.push(eventRecord.data.startDate);

                    if (Vue.prototype.$checkSingleOccurrence(eventRecord.data.crew, 'I') || Vue.prototype.$checkSingleOccurrence(eventRecord.data.crew, 'T') || Vue.prototype.$checkSingleOccurrence(eventRecord.data.crew, 'C')) {
                        isThisATrainingsFlight = true;
                    }

                    resourcesIdstoRemove.push(eventRecord.data.resourceId);
                    resourcesContractCodetoAdd += resourceRecord.data.contract3Code;
                }


                // >>> build & run ------------------------
                params = {
                    params: {
                        "idFlights": idFlightsArray,
                        "resourcesIdstoAdd": [],
                        "resourcesIdstoRemove": resourcesIdstoRemove
                    },
                    draggedRecords: null,
                    newResource: null
                };


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: startDatesArray, isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                // >>> 'Warning/Call' -----------------
                me.actn_set_Warning({
                    title: 'Delete CrewMembers(s) from Flight(s)',
                    text:   `<div>
                                <p style="margin: 0; text-align: center">Do you really want to delete these Crewmember(s) ?</p>
                                <div style="display:flex;padding-top:28px;font-weight:500">
                                    <div style="padding-top:0;flex: 0 0 70px;margin-right:18px;border-right:1px solid #757575;"></div>
                                    <div style="padding-top:0;flex: 1;">From - To</div>
                                    <div style="padding-top:0;flex: 1;">For Member(s)</div>
                                </div>

                                ${this.get_selectedMultiEvents('FLIGHT').map((record) => `
                                    <div style="display:flex;border-top: 1px solid #757575;">
                                        <div style="padding-top:4px;flex: 0 0 70px;margin-right:18px;border-right:1px solid #757575;">-</div>
                                        <div style="padding-top:4px;flex: 1;">${record.nameEvent.replace('<br />', '-')}</div>
                                        <div style="padding-top:4px;flex: 1;">${resourcesContractCodetoAdd}</div>
                                    </div>
                                `).join(' ')}

                                ${isThisATrainingsFlight ? '<br /><br /><p style="margin: 0; text-align: center; color: red; font-weight: 600;">Attention: This is a Trainings-Flight. You are moving "Instructors", "Checker" or "Trainee".</p>' : ''}
                            `,
                    payload: null,
                    acceptFunction: () => me.actn_call_deleteCrewmemberFromFlights(params),
                    declineFunction: () => null,
                });

            }, // eo function onDelete_MemberFromFlight()


            /*******************************************************************
            * onShow_CrewDetails()
            *
            * Desc: Show Crew Details (Sheet).
            * Note: 'Call 1' and 'Call 2' here.
            * Note: From 'Call 3' on ... directly after Call 1 (look into Store).
            *
            * @param {Object} obj ((Right) Clicked Flight)
            */
            onShow_CrewDetails: function(obj) {

                let me = this,
                    { eventRecord } = obj;


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onShow_CrewDetails');
                if (eventRecord.data.legInfo.crewCodes.length !== 0) { // '.. with crew on it only!'
                    // Call 1: 'Crew Details'
                    me.actn_call_getCrewDetailsFromFlight({
                        idFlightGroup: eventRecord.data.legInfo.idFlightGroup,
                        idFlight: eventRecord.data.id,
                        date: dayjs(eventRecord.data.startDate).format('YYYY-MM-DDT23:59:59'),
                        from: dayjs(eventRecord.data.startDate).format('YYYY-MM-DDT00:00:00'), // note: no 'Z' appended
                        to: dayjs(eventRecord.data.endDate).format('YYYY-MM-DDT23:59:59'),
                    });

                    // Call 2: 'Crew Details (reduced)'
                    me.actn_call_getCrewDetailsFromFlight_Reduced({ idFlight: eventRecord.data.id });


                    me.eventRecord = eventRecord;
                    me.editorMode = 'create';
                    me.showSheetCrewDetails = true;
                }

            }, // eo function onShow_CrewDetails()


            /*******************************************************************
            * onUpdate_CrewOnFlight()
            *
            * Desc: Prepare and open 'Crew Update Sheet',
            * Note: Check if edit in past is allowed.
            *
            * @param {Object} obj (Clicked Resource)
            */
            onUpdate_CrewOnFlight: function(event) {

                let me = this,
                    flightIds = [],
                    crewCodes = [],
                    startDatesArray = [],
                    { eventRecord } = event;


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onUpdate_CrewOnFlight');
                if (this.get_selectedMultiEventsFlights().length > 1) {
                    this.get_selectedMultiEventsFlights().forEach(flight => { // build 'flightIds'
                        if (!flightIds.includes(flight.id)) {
                            flightIds.push(flight.id);
                            startDatesArray.push(flight.startDate);
                        }

                        flight.legInfo.crewCodes.forEach(crewmember => { // build 'crewCodes'
                            if (!crewCodes.includes(crewmember)) {
                                crewCodes.push(crewmember)
                            }
                        });
                    });
                }
                // <<< multiple flights chosen ------------


                // >>> single flight chosen ---------------
                if (this.get_selectedMultiEventsFlights().length === 0 || this.get_selectedMultiEventsFlights().length === 1) {
                    crewCodes = eventRecord.data.legInfo.crewCodes; // catch: single one
                    flightIds.push(eventRecord.data.legInfo.idFlight); // catch: single one
                    startDatesArray.push(eventRecord.data.startDate); // catch: single one
                }
                // <<< single flight chosen ---------------


                if (!Vue.prototype.$isActionAllowed({ datesToCheck: startDatesArray, isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                // >>> ------------------------------------
				// me.actn_call_getMemberOnCrew(obj); // from original: load crew
				me.actn_set_getMemberOnCrew({ crewCodes: crewCodes, flightIds: flightIds }); // mimic original idea (from 'People')
                me.showSheet_MemberOnCrew = true;

            }, // eo function onUpdate_CrewOnFlight()


            /*******************************************************************
            * onCloseSheet_CrewOnFlight()
            *
            * Desc: Close 'Crew Uopdate' Sheet again (after update).
            * Note:
            *
            */
            onCloseSheet_CrewOnFlight: function(event) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onCloseSheet_CrewOnFlight');
                me.showSheet_MemberOnCrew = false;

            }, // eo function onCloseSheet_CrewOnFlight()


            /*******************************************************************
            * onFilter_ForCrewOnCalendar()
            *
            * Desc:
            * Note:
            *
            * @param {Object} obj (Clicked Resource)
            */
            onFilter_ForCrewOnCalendar: function(event) {

                let me = this,
                    crewCodes = [],
                    { eventRecord } = event,
                    schedulerCalendar = this.$refs.scheduler1.instance; // 'Calendar'


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> onFilter_ForCrewOnCalendar');
                // >>> multiple flights chosen ------------
                if (this.get_selectedMultiEventsFlights().length > 1) {
                    this.get_selectedMultiEventsFlights().forEach(flight => {   // build 'crewCodes'
                        flight.legInfo.crewCodes.forEach(crewmember => {
                            if (!crewCodes.includes(crewmember)) {
                                crewCodes.push(crewmember);
                            }
                        });
                    });
                }


                // >>> single flight chosen ---------------
                if (this.get_selectedMultiEventsFlights().length === 0 || this.get_selectedMultiEventsFlights().length === 1) {
                    crewCodes = eventRecord.data.legInfo.crewCodes; // catch: single one
                }


                // >>> ------------------------------------
                if (crewCodes.length > 0) {
                    schedulerCalendar.resourceStore.filter({
                        filters : r =>  crewCodes.includes(r.contract3Code),
                        replace : true
                    });
                }


            }, // eo function onFilter_ForCrewOnCalendar()



            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validator_ResourcesOnFlights()
            *
            * Desc:
            * Note:
            *
            */
            validator_ResourcesOnFlights: function() {

                let me = this,
                    isValid = true;


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> validator_ResourcesOnFlights');
                // >>> 'At least 1 Flight'
                if (this.get_selectedMultiEventsFlights().length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Pardon this is not possible. Choose 1 Flight at least.'
                    });
                    isValid = false;
                }

                // >>> 'At Least 1 Resource'
                if (this.get_selectedMultiResources.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Pardon this is not possible. Choose 1 Ressource at least.'
                    });
                    isValid = false;
                }

                // >>> 'Only one Airplane?'
                if (this.get_selectedMultiResourcesFlights.length > 1) {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Pardon this is not possible. Choose only Flights from 1 Airplane.'
                    });
                    isValid = false;
                }


                return isValid;

            }, // eo function validator_ResourcesOnFlights()


            /*******************************************************************
            * validator_FlightsOnSameDay()
            *
            * Desc: Are all records on same day?
            * Note:
            *
            */
            validator_FlightsOnSameDay: function(records) {

                let me = this,
                    firstRecFormatted = '',
                    recFormatted = '',
                    isValid = true;


                me.$toc('>>> views/crewplanning/crewplanning/mixins/Mixin_DragAndDrop.vue >>> validator_FlightsOnSameDay');
                if (records.length > 1) {
                    firstRecFormatted = dayjs(records[0].startDate).format('DD/MM/YYYY');
                    records.forEach((rec) => {
                        recFormatted = dayjs(rec.startDate).format('DD/MM/YYYY');
                        if (dayjs(firstRecFormatted).isSame(dayjs(recFormatted, 'day')) === false) {
                            isValid = false;
                        }
                    })
                }


                return isValid;

            }, // eo function validator_FlightsOnSameDay()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>
